import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getRepairReportApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;
  const status = error?.response?.status;

  if (status === 404 || code === 'REPAIR_REPORT_NOT_FOUND') {
    return data?.message
      || '找不到維修報告（API 可能尚未部署／target）';
  }

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  if (code === 'REPAIR_REPORT_ALREADY_EXISTS') {
    return data?.message || '此維修品項已有報告，請開啟既有報告';
  }

  if (code === 'REPAIR_REPORT_NO_REQUIRED') {
    return data?.message || '請填寫維修報告單號';
  }

  if (code === 'REPAIR_REPORT_NO_DUPLICATED') {
    return data?.message || '維修報告單號已存在，請改用其他單號';
  }

  if (code === 'REPAIR_REPORT_REQUIRED_FIELD') {
    return data?.message || '完成前尚有必填欄位未填';
  }

  if (code === 'REPAIR_REPORT_REFUSE_REASON_REQUIRED') {
    return data?.message || '請填寫拒修原因';
  }

  if (code === 'REPAIR_REPORT_UPDATE_NOT_ALLOWED') {
    return data?.message || '僅草稿可編輯';
  }

  if (code === 'REPAIR_REPORT_COMPLETE_NOT_ALLOWED') {
    return data?.message || '僅草稿可完成';
  }

  if (code === 'REPAIR_REPORT_REFUSE_NOT_ALLOWED') {
    return data?.message || '僅草稿可拒修';
  }

  if (code === 'REPAIR_REPORT_CANCEL_REASON_REQUIRED') {
    return data?.message || '請填寫取消原因';
  }

  if (code === 'REPAIR_REPORT_CANCEL_NOT_ALLOWED') {
    return data?.message || '僅未鎖定的草稿可取消';
  }

  if (code === 'REQUEST_BODY_INVALID') {
    const field = data?.field ?? data?.details?.field;
    if (field === 'accessories' || field === 'problem_description'
      || field === 'problemDescription') {
      return data?.message || '配件與問題描述為唯讀，請勿傳送';
    }
    return data?.message || '送出的內容不符合格式';
  }

  if (status >= 500) {
    return data?.message || '維修報告服務異常（可能尚未部署 target API）';
  }

  return data?.message || fallback;
}

export function isRepairReportVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}

export function isRepairReportAlreadyExists(error) {
  return error?.response?.data?.code === 'REPAIR_REPORT_ALREADY_EXISTS';
}

export function isRepairReportNoDuplicated(error) {
  return error?.response?.data?.code === 'REPAIR_REPORT_NO_DUPLICATED';
}

/** 盡量從 409 ALREADY_EXISTS details 取出既有報告 id。 */
export function getExistingRepairReportIdFromError(error) {
  const details = error?.response?.data?.details;
  if (!details || typeof details !== 'object') {
    return null;
  }
  return details.repairReportId
    ?? details.repair_report_id
    ?? details.existingId
    ?? details.existing_id
    ?? details.id
    ?? null;
}
